<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">Hi~ <a class="font3">{{ ReportData.stuname }}</a>，我们又见面啦</p>
        <p  class="font1">一起回顾<a class="font3">2024</a>年的成长点滴吧</p>

        <p class="font1" style="padding-top: 1vh;">2024年即将过去</p>
        <p class="font1">感谢你</p>
        <p class="font1">与富士康科技集团携手走过<a class="font3">{{ ReportData.hyear }}</a>年~</p>

        <p class="font1">这一年</p>
        <p class="font1">你在富学宝典平台上的学习天数达到了<a class="font3">{{ ReportData.studate }}</a>天</p>

        <div v-if=" ReportData.hyear>=0 && ReportData.hyear<1" style="text-align: center;margin-top: 10vh;">
            <img  src="../../assets/24year/png1.png" style="width: 3ch;">
            <p  style="text-align: center;color: #fff;margin: 0;">羽翼虽稚嫩，心志已昂~</p>
            <p  style="text-align: center;color: #fff;margin-top: 0;">用积累迎接属于你的起航</p>
        </div>
        <div v-else-if=" ReportData.hyear>=1 && ReportData.hyear<3" style="text-align: center;margin-top: 10vh;">
            <img src="../../assets/24year/png4.png" style="width: 30%;">
            <p  style="text-align: center;color: #fff;margin: 0;">羽翼正丰满，迎风而行~</p>
            <p  style="text-align: center;color: #fff;margin-top: 0;">用坚持探索属于你的天地​</p>
        </div>
        <div v-else-if=" ReportData.hyear>=3 && ReportData.hyear<5" style="text-align: center;margin-top: 10vh;">
            <img src="../../assets/24year/png6.png" style="width: 40%;"> 
            <p  style="text-align: center;color: #fff;margin: 0;">羽羽翼已成型，乘风而起​~</p>
            <p  style="text-align: center;color: #fff;margin-top: 0;">用努力开辟属于自己的天空</p>
        </div>
        <div v-else-if=" ReportData.hyear>=5 && ReportData.hyear<10" style="text-align: center;margin-top: 10vh;">
            <img src="../../assets/24year/png8.png" style="width: 40%;">
            <p  style="text-align: center;color: #fff;margin: 0;">羽翼已强健，搏击长空​~</p>
            <p  style="text-align: center;color: #fff;margin-top: 0;">用智慧追踪属于自己的高度​</p>
        </div>
        <div v-else-if=" ReportData.hyear>=10 && ReportData.hyear<15" style="text-align: center;margin-top: 10vh;">         
            <img  src="../../assets/24year/png7.png" style="width: 40%;"> 
            <p  style="text-align: center;color: #fff;margin: 0;">羽翼愈坚韧，已领风云​~</p>
            <p  style="text-align: center;color: #fff;margin-top: 0;">用经验电量属于你的方向</p>
        </div>
        <div v-else style="text-align: center;margin-top: 10vh;">
            <img src="../../assets/24year/png10.png" style="width: 40%;">
            <p  style="text-align: center;color: #fff;margin: 0;">羽翼如山岳。傲立云端​~</p>
            <p  style="text-align: center;color: #fff;margin-top: 0;">用格局俯瞰属于你的天地</p>
        </div>

        <p style="padding-top: 8vh;color:#fff;text-align: center;">左滑，查看我的年度学习报告》》</p>
    </div>
</template>
  
<script>

export default {
      props: [ "ReportData"],
      data() {
        return {   
        }
      },
      created() {
        
      }
}
</script>
  
<style scoped>
.body {
    background:url("../../assets/24year/bg5.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
}

.font1 {
    width: 92%;
    margin: 0;
    text-align: right;
    font-size: 17px;
    color: #1740f7;

    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    color: #000;
    font-size: 15px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 25px;
    color: 1f4df9;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>